class NSSAnnouncements extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Announcements] Connected.");

    this.initCarousel();

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ]
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  updateArrowColor() {
    const msgEl = this.querySelector(`.swiper-slide-active`);
    if (msgEl) {
      const color = window.getComputedStyle(msgEl).color;
      if (this.debug) console.log("[NSS][Announcements] color:", color);
      const controlsEl = this.querySelector(`.nss-announcements__controls`);
      controlsEl.style.color = color;
    }
  }

  initCarousel() {

    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      loop: true,
      autoHeight: false,
      grabCursor: true,
      slidesPerView: 1,

      a11y: {
        enabled: true,
      },
    
      navigation: {
        prevEl: '.nss-announcements-prev',
        nextEl: '.nss-announcements-next',
      },

      on: {
        init: () => {
          this.updateArrowColor();
        },
        slideChangeTransitionEnd: () => {
          this.updateArrowColor();
        },
      },
    });
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Announcements] Handle editor event, e:", e);

    switch(e.type) {

      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Learn More] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Learn More] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;

    }
  }
}

let elementName = `nss-announcements`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAnnouncements);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}